<template>
  <div class="tinymce-box fit">
    <editor ref="editor" v-model="myValue" :init="init" :disabled="disabled" @click="onClick"> </editor>
    <a-modal destroy-on-close centered title="插入图片" :width="700" v-model="showImageSettings" :body-style="{ padding: '15px 20px' }" @cancel="handleCancelUpload">
      <template slot="footer">
        <a-button key="back" @click="handleCancelUpload">取消</a-button>
        <a-button :disabled="!imageFiles.length" key="submit" type="primary" @click="handleImageSelect">确认插入</a-button>
      </template>
      <div class="file-settings flex full-height overflow-hidden">
        <div class="file-settings-preview" style="width: 260px">
          <a-upload
            :action="`${baseURL}/file/upload`"
            :data="{
              params: JSON.stringify(fileParams),
            }"
            :file-list="imageFiles"
            :before-upload="beforeUploadFile"
            @preview="handlePreviewFile"
            @change="info => handleUploadChange(info, 1, 'imageFiles')"
            list-type="picture-card"
            class="picture-uploader picture-uploader-raise overflow-hidden"
            accept=".png, .jpg, .jpeg, .gif"
            ref="imageFiles"
          >
            <div v-if="imageFiles.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
          <!-- <div class="file-settings-preview__img" title="点击查看原图" v-else>
            <img :src="imageForm.url" />
          </div> -->
          <!-- <span class="v-mt-xs">图片预览</span> -->
        </div>
        <div class="file-settings-content col relative-position">
          <a-form-model ref="imageForm" :model="imageForm">
            <a-row :gutter="24">
              <!-- <a-col :span="24">
                <a-form-model-item prop="url">
                  <span slot="label">链接地址<span class="text-red font-xs">（必填）</span> </span>
                  <a-input ref="imageUrl" v-model="imageForm.url" placeholder="链接地址" />
                </a-form-model-item>
              </a-col> -->
              <a-col :span="24">
                <a-form-model-item label="图片描述" prop="alt">
                  <a-input ref="imageAlt" v-model="imageForm.alt" placeholder="图片描述" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="宽" prop="width">
                  <a-input type="number" v-model="imageForm.width"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="高" prop="height">
                  <a-input type="number" v-model="imageForm.height"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </div>
    </a-modal>
    <a-modal destroy-on-close centered title="插入视频" :width="700" v-model="showVideoSettings" :body-style="{ padding: '15px 20px' }" @cancel="handleCancelUpload">
      <template slot="footer">
        <a-button key="back" @click="handleCancelUpload">取消</a-button>
        <a-button :disabled="!imageForm.url" key="submit" type="primary" @click="handleVideoSelect">确认插入</a-button>
      </template>
      <div class="file-settings flex full-height">
        <div class="file-settings-preview" style="width: 260px">
          <div class="file-settings-preview__video">
            <a-upload-dragger
              :action="`${baseURL}/file/upload`"
              :data="{
                params: JSON.stringify(fileParams),
              }"
              :file-list="videoFiles"
              :before-upload="beforeUploadFile"
              @preview="handlePreviewFile"
              @change="info => handleUploadChange(info, 1, 'videoFiles')"
              class="picture-uploader-raise overflow-hidden"
              accept=".avi,.mp4,.mov,.mkv,.rm,.rmvb,.flv,.wmv"
              ref="videoFiles"
              v-if="!imageForm.url"
            >
              <div v-if="videoFiles.length === 0">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传视频</div>
              </div>
            </a-upload-dragger>
            <player :url="imageForm.url" :config="{ videoInit: true }" v-else/>
          </div>
          <!-- <span class="v-mt-xs">图片预览</span> -->
        </div>
        <div class="file-settings-content col relative-position">
          <a-form-model ref="imageForm" :model="imageForm">
            <a-row :gutter="24">
              <!-- <a-col :span="24">
                <a-form-model-item prop="url">
                  <span slot="label">链接地址<span class="text-red font-xs">（必填）</span> </span>
                  <a-input ref="imageUrl" v-model="imageForm.url" placeholder="链接地址" />
                </a-form-model-item>
              </a-col> -->
              <a-col :span="24">
                <a-form-model-item label="视频描述" prop="alt">
                  <a-input ref="imageAlt" v-model="imageForm.alt" placeholder="视频描述" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="宽" prop="width">
                  <a-input type="number" v-model="imageForm.width"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="高" prop="height">
                  <a-input type="number" v-model="imageForm.height"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Player from './player'
// 文档 http://tinymce.ax-z.cn/
// 引入组件
import tinymce from 'tinymce/tinymce' // tinymce默认hidden，不引入不显示
import Editor from '@tinymce/tinymce-vue'

// 引入富文本编辑器主题的js和css
// import 'tinymce/skins/content/default/content.css'
import 'tinymce/themes/silver/theme.min.js'
// import 'tinymce/icons/default/icons' // 解决了icons.js 报错Unexpected token '<'

// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' // 插入视频插件
import 'tinymce/plugins/table' // 插入表格插件
import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/wordcount' // 字数统计插件
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/help'
export default {
  components: {
    Editor,
    Player,
  },
  name: 'Tinymce',
  props: {
    // 默认的富文本内容
    value: {
      type: String,
      default: '',
    },
    minHeight: {
      type: Number,
      default: 300,
    },
    fileParams: {
      type: Object,
      default: () => {},
    },
    // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
    // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
    baseUrl: {
      type: String,
      default: window.location.origin ? window.location.origin : '',
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: 'link lists image code table wordcount media preview fullscreen autoresize help',
    },
    toolbar: {
      type: [String, Array],
      default: 'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | undo redo | link unlink code lists table imgSelector videoSelector | removeformat | fullscreen preview',
    },
  },
  data() {
    let vm = this
    return {
      init: {
        language_url: './tinymce/langs/zh_CN.js',
        // language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
        language: 'zh_CN',
        skin_url: './tinymce/skins/ui/oxide',
        // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
        // skin_url: 'tinymce/skins/ui/oxide-dark', // 暗色系
        convert_urls: false,
        height: 600,
        min_height: 400,
        // content_css（为编辑区指定css文件）,加上就不显示字数统计了
        // content_css: `${this.baseUrl}tinymce/skins/content/default/content.css`,
        // （指定需加载的插件）
        plugins: this.plugins,
        toolbar: this.toolbar, // （自定义工具栏）
        toolbar_sticky: true,
        content_style: 'h1,h2,h3,h4,h5,h6 { margin-bottom: .65em;margin-top: 0; } p {margin-top: 0;margin-bottom:1em;} img { max-width: 100%}',
        setup: function (editor) {
          editor.on('init', function (ed) {
            // ed.target.editorCommands.execCommand('fontName', false, '微软雅黑')
            // ed.target.editorCommands.execCommand("fontSize", false, '14px')
            this.getBody().style.fontSize = '14px';
            // this.getBody().style.color = '#843FA1';
            this.getBody().style.fontFamily = '微软雅黑';
          })
          // 注册一个自定义的按钮
          editor.ui.registry.addButton('imgSelector', {
            icon: 'image',
            onAction: () => {
              vm.materialType = 1
              // vm.showMaterialLib = true
              vm.showImageSettings = true
            },
          })
          editor.ui.registry.addButton('videoSelector', {
            icon: 'embed',
            onAction: () => {
              vm.materialType = 3
              vm.showVideoSettings = true
            },
          })
        },
        statusbar: true, // 底部的状态栏
        menubar: false,
        // menubar: 'file edit view format table tools', // （1级菜单）最上方的菜单
        branding: false, // （隐藏右下角技术支持）水印“Powered by TinyMCE”
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          // let form = new FormData()
          // form.append('file', blobInfo.blob(), blobInfo.filename())
          // this.uploadFile(form).then((data) => {
          //   success(`${this.fileBaseURL}/file/${data.id}`)
          // })
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        },
      },
      showMaterialLib: false,
      showImageSettings: false,
      showVideoSettings: false,
      imageForm: {
        url: '',
        alt: '',
        width: undefined,
        height: undefined,
      },
      imageFiles: [],
      videoFiles: [],
      materialType: 1,
      myValue: this.value,
      selectedFile: null,
    }
  },
  mounted() {
    // tinymce.init({})
  },
  methods: {
    ...mapActions(['uploadFile', 'addMaterial', 'getMaterialByPage']),
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = ''
    },
    onMaterialSelect(file, fileClassify) {
      this.imageForm.url = `${this.fileBaseURL}/file/${file.fileId}`
      this.selectedFile = file
      if (fileClassify === 1) {
        this.showImageSettings = true
      } else {
        this.showVideoSettings = true
      }
    },
    handleImageSelect() {
      this.showImageSettings = false
      this.showMaterialLib = false
      // this.$refs.editor.editor.insertContent(
      //   '<svg width="24" height="24"><path d="M5 15.7l3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7zM5 18V19h3l2.8-2.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 0 1-1-1V4c0-.6.4-1 1-1zm6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill-rule="nonzero"></path></svg>'
      // )
      let { url, alt, width, height } = this.imageForm
      let html = []
      html.push(`<p><img src="${url}" `)
      if (alt) {
        html.push(` alt="${alt}"`)
      }
      // if (width) {
      //   html.push(` width="${width}"`)
      // }
      html.push(` width="${width ? width + 'px' : '100%'}"`)
      if (height) {
        html.push(` height="${height}"`)
      }
      html.push('/></p>')
      this.$refs.editor.editor.insertContent(html.join(''))
    },
    handleVideoSelect() {
      this.showVideoSettings = false
      this.showMaterialLib = false
      // let { url } = this.imageForm
      let { url, alt, width, height } = this.imageForm
      let html = []
      html.push(`<p><video mediatype="video" controls="controls" src="${url}" `)
      if (alt) {
        html.push(` alt="${alt}"`)
      }
      html.push(` width="${width ? width + 'px' : '100%'}"`)
      html.push(` height="${height || 400}"`)
      html.push('/></p>')
      this.$refs.editor.editor.insertContent(html.join(''))
    },
    handleCancelUpload() {
      this.showImageSettings = false
      this.showVideoSettings = false
      this.imageForm.url = ''
      this.imageFiles = []
      this.videoFiles = []
    },
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
        let { status } = info.file
        if (status === 'done') {
          let { fileId, raiseId, fileSign } = this[ref][0]
          this.imageForm.url = `${this.baseURL}/file/view?id=${fileId}&belongId=${raiseId}&fileSign=${fileSign}`
        }
      }
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    },
  },
}
</script>
<style lang="stylus">
.tinymce-box
  .tox .tox-tbtn--bespoke .tox-tbtn__select-label
    width 4em
//   border 0 none
.file-settings
  .ant-form-item
    margin-bottom 8px
  .ant-form-item-label
    line-height 22px
.file-settings-preview
  position relative
  padding-right 15px
  display flex
  // align-items center
  justify-content center
  // flex-direction column
  &__img
    width 100%
    // height 210px
    margin-left 0px
    max-height 200px
    overflow hidden
    padding 5px
    border 1px solid $grey-3
    box-sizing content-box
    cursor pointer
    &:hover
      border-color $primary
    img
      max-width 100%
  &__video
    width 100%
    // height 210px
    margin-left 0px
    max-height 200px
    overflow hidden
</style>
